<template>
  <v-toolbar class="pr-0" color="primary" dark dense flat>
    <v-toolbar-title>
      <v-icon v-if="active" :size="15" color="success">fas fa-circle</v-icon>
      <v-icon v-else :size="15">fas fa-clock</v-icon>
      <span class="ml-2" style="font-size: 0.75rem;">{{ time }}</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-tooltip top transition="scroll-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon @click="locate" v-if="locating_progress === 100">
          <v-icon :size="15" dark>fa-radar</v-icon>
        </v-btn>
        <v-btn icon v-on="on" v-else disabled>
          <v-progress-circular
                               :rotate="180"
                               :value="locating_progress"
                               :size="30"
                               :width="2"
                               color="white">
            <v-icon :size="15" dark>fa-radar</v-icon>
          </v-progress-circular>
        </v-btn>
      </template>
      <span>{{ t({s: 'tooltips.locate', component: 'Missing'}) }}</span>
    </v-tooltip>

    <v-tooltip top transition="scroll-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon @click="resolve">
          <v-icon :size="15" dark>fa-check</v-icon>
        </v-btn>
      </template>
      <span>{{ t({s: 'tooltips.resolve', component: 'Missing'}) }}</span>
    </v-tooltip>

    <v-tooltip top transition="scroll-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon @click="close">
          <v-icon :size="15" dark>fa-times-circle</v-icon>
        </v-btn>
      </template>
      <span>{{ t({s: 'tooltips.close', component: 'Missing'}) }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toolbar',
  props: ['item'],
  data () {
    return {
      locating_progress: 100,
      update_interval: null
    }
  },
  computed: {
    ...mapState(['timezone']),
    positioned_at () {
      return this.item.positioned_at ? this.$moment.utc(this.item.positioned_at) : false
    },
    active () {
      const check = this.$moment().utc().subtract(1, 'hours')
      return this.positioned_at ? this.positioned_at.isAfter(check) : false
    },
    time () {
      if (!this.positioned_at) {
        return '-:-'
      }

      if (this.$moment().utc().isSame(this.positioned_at, 'day')) {
        return this.positioned_at.format('HH:mm')
      }

      return this.positioned_at.fromNow()
    }
  },
  methods: {
    updateProgress () {
      const getProgress = () => {
        if (this.item?.bluetooth_toggled_at === null) {
          return 100
        }

        const now = this.$moment.utc().subtract(10, 'minutes')
        const toggled_at = this.$moment.utc(this.item.bluetooth_toggled_at)
        if (now.isAfter(toggled_at)) {
          return 100
        }

        // bluetooth stays on for 10 minutes
        return (toggled_at.diff(now, 'seconds') / 600) * 100
      }

      if (this.update_interval !== null) {
        clearInterval(this.update_interval)
      }

      this.locating_progress = getProgress()
      this.update_interval = setInterval(() => {
        this.locating_progress = getProgress()
      }, 30 * 1000)
    },
    showMessage (text, type = 'success') {
      if (this.$route.path !== '/missing') {
        this.$router.push('/missing')
      }

      this.$store.commit('Map/setMessage', {
        message: {
          body: text,
          type: type
        }
      })
    },
    async locate () {
      this.axios.put(`missing/${this.item.id}/locate`).then(response => {
        this.showMessage(this.t({ s: 'messages.locating.success', component: 'Missing' }))
      }).catch(e => {
        this.showMessage(this.t({ s: 'messages.locating.failed', component: 'Missing' }), 'warning')
      })
    },
    async resolve () {
      const { isConfirmed } = await this.$swal({
        title: this.t({ s: 'confirmTitle', component: 'messages' }),
        text: this.t({ s: 'confirmResolveText', component: 'messages' }, [this.item.number]),
        icon: 'warning',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: true,
        cancelButtonText: this.t({ s: 'cancelButtonText', component: 'messages' }),
        confirmButtonText: this.t({ s: 'confirmButtonText', component: 'messages' }, [this.t({
          s: 'confirmResolve',
          component: 'messages'
        })])
      })

      if (!isConfirmed) {
        return
      }

      this.axios.put(`missing/${this.item.id}/resolve`).then(response => {
        this.showMessage(this.t({ s: 'messages.resolved', component: 'Missing' }))
      })
    },
    async close () {
      const { isConfirmed } = await this.$swal({
        title: this.t({ s: 'confirmTitle', component: 'messages' }),
        text: this.t({ s: 'confirmCloseText', component: 'messages' }, [this.item.number]),
        icon: 'warning',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: true,
        cancelButtonText: this.t({ s: 'cancelButtonText', component: 'messages' }),
        confirmButtonText: this.t({ s: 'confirmButtonText', component: 'messages' }, [this.t({
          s: 'confirmClose',
          component: 'messages'
        })])
      })

      if (!isConfirmed) {
        return
      }

      this.axios.put(`missing/${this.item.id}/close`).then(response => {
        this.showMessage(this.t({ s: 'messages.closed', component: 'Missing' }))
      })
    }
  },
  mounted () {
    this.updateProgress()
  },
  watch: {
    item () {
      this.updateProgress()
    }
  }
}
</script>
